const symbols = {
    nestingFormKey: Symbol('nestingFormKey')
}

export default symbols
